import React from 'react';
import MuiDialog from "../../../atoms/muiDialog";
import {Button, Typography, Divider} from "@material-ui/core";
import HelpIcon from '@material-ui/icons/Help';
import {css} from "@emotion/react";

// setting
import colorPalette from "../../../../styles/theme/colorPalette"
import {makeStyles} from "@material-ui/styles";

const HealthyLarge = () => {
  
  const [open, setOpen] = React.useState(false);
  
  const handleClose = (value) => {
    setOpen(false);
  };
  
  const handleClickOpen = () => {
    setOpen(true);
  };
  
  const useStyles = makeStyles({
    dialogPaper: {
      borderRadius: '24px',
      square: false
    },
  })
  
  const classes = useStyles()
  
  return (
      <>
        <HelpIcon color='primary' onClick={handleClickOpen} css={cursor}/>
        <MuiDialog
            onClose={handleClose}
            open={open}
            fullWidth={true}
            maxWidth='lg'
            css={dialogStyle}
            closeBtnColor={colorPalette.itemCategories.healthy}
            classes={{paper: classes.dialogPaper}}>
          <div css={innerBox}>
            <hr css={style}/>
            <p css={title}>ヘルシー食多め</p>
            <p css={subTitle}>
              糖尿病食、脂質異常食、高血圧食としても<br/>
              お召し上がりいただけるように栄養士が開発
            </p>
            <hr css={style}/>
            <div css={comment}>
              エネルギーや塩分を調整したお食事で、全ての商品で塩分を2.0g未満に調整してあります。
              ヘルシー食では分量が少ないという方に向けて、内容量をおかずのみの商品で300g以上、ごはん付きで400g以上に調整しております。
              エネルギーをおかずのみの商品で350kcal程度、ごはん付きで600kcal程度に調整してあります。
              糖尿病・脂質異常症・高血圧・痛風の方向け、メタボ対策、ダイエットにおすすめです。
            </div>
          </div>
        </MuiDialog>
      </>
  );
};

export default HealthyLarge;

const dialogStyle = css`
  border-radius: 16px;
`

const cursor = css`
  cursor: pointer;
`

const style = css`
  border-top: solid 1px ${colorPalette.itemCategories.healthy};
`

const title = css`
  font-size: 32px;
  margin-bottom: 16px;
  text-align: center;
  color: ${colorPalette.itemCategories.healthy};
`

const subTitle = css`
  font-size: 24px;
  text-align: center;
  color: ${colorPalette.itemCategories.healthy};
`

const innerBox = css`
  max-width: 640px;
  padding: 32px 24px;
  margin: 16px auto 0;
`
const comment = css`
  margin-top: 24px;
`